import React, { FC } from "react";
import { ISvG } from "~/types/SvGTypes";

const PrintIcon: FC<ISvG> = ({ stroke = "#ffffff" }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 13.5H1.5V6H16.5V13.5H12.75M12.75 6V1.83333C12.75 1.3731 12.3303 1 11.8125 1H6.1875C5.66973 1 5.25 1.3731 5.25 1.83333V6M5.25 11H12.75V16H5.25V11Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PrintIcon;
